export default "__VITE_ASSET__DccwwgnE__"